module.exports = __webpack_public_path__ + "img/MGH-Toyosu-5.2cefffd0.jpg";